function e(_ref) {
  let e = _ref.storage,
    _ref$sync = _ref.sync,
    t = _ref$sync === void 0 ? !1 : _ref$sync,
    _ref$serialize = _ref.serialize,
    r = _ref$serialize === void 0 ? JSON.stringify : _ref$serialize,
    _ref$deserialize = _ref.deserialize,
    n = _ref$deserialize === void 0 ? JSON.parse : _ref$deserialize;
  var a = (a, i) => (t && "undefined" != typeof addEventListener && addEventListener("storage", t => {
    t.storageArea === e && (t.key === a && i(t.newValue), null === t.key && i(null));
  }), {
    get(t) {
      var r = void 0 !== t ? t : e.getItem(a);
      return void 0 === t && null === r ? void 0 : n(r);
    },
    set(t) {
      e.setItem(a, r(t));
    }
  });
  return a.keyArea = e, a;
}
export { e as storage };